module.exports = __webpack_public_path__ + "9c5cffbaa804eec4892d42bba94a0274.svg";